import { render, staticRenderFns } from "./CommunityContent.vue?vue&type=template&id=74c97e9c&scoped=true&"
import script from "./CommunityContent.vue?vue&type=script&lang=js&"
export * from "./CommunityContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c97e9c",
  null
  
)

export default component.exports